// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tax-optimisation_content__q\\+q9Y {
    display: flex;
    grid-gap: 40px;
    /*width: calc(100vw - 200px);*/
    max-width: 100%;
    padding: 18px var(--container-padding);
    margin: auto;
}

.tax-optimisation_groupsContainer__8TA5K {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    position: relative;
}

.tax-optimisation_groups__9uLxY {
    display: inline-flex;
    flex-wrap: wrap;
    grid-gap: 69px;
    margin: 0 auto;
    min-width: 1086px;
}

.tax-optimisation_group__5c-yj {
    position: relative;
    width: 250px;
    /*transition: 0.1s;*/
}

.tax-optimisation_groupTitle__4QfpL {
    margin: 0 0 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.tax-optimisation_groupTitle__4QfpL button.tax-optimisation_hidden__qBIDP {
    display: none;
}

.tax-optimisation_groupTitle__4QfpL h4 {
    color: #000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    width: 270px;
    margin: auto 0;
}

.tax-optimisation_group__5c-yj.tax-optimisation_closed__MjbEM .tax-optimisation_groupTitleNumber__Z3l4q {
    display: none;
}

.tax-optimisation_groupTitleNumber__Z3l4q {
    color: var(--secondary-color);
    font-weight: 400;
    padding-right: 10px;
}

.tax-optimisation_groupItems__U59zN {
    display: flex;
    flex-wrap: wrap;
    transition: padding 0.1s;
}

.tax-optimisation_groupItems__U59zN.tax-optimisation_closed__MjbEM:has(a:nth-child(2):last-child) {
    padding-top: 8px;
    padding-left: 8px;
}

.tax-optimisation_groupItems__U59zN.tax-optimisation_closed__MjbEM:has(a:nth-child(3):last-child) {
    padding-top: 16px;
    padding-left: 16px;
}

.tax-optimisation_groupItems__U59zN.tax-optimisation_closed__MjbEM:has(a:nth-child(4)) {
    padding-top: 24px;
    padding-left: 24px;
}

.tax-optimisation_groupItems__U59zN.tax-optimisation_closed__MjbEM * {
    pointer-events: none;
}

.tax-optimisation_groupItems__U59zN.tax-optimisation_open__1Ixrb {
    row-gap: 32px;
}

.tax-optimisation_group__5c-yj.tax-optimisation_open__1Ixrb {
    width: 100%;
}

.tax-optimisation_group__5c-yj.tax-optimisation_hidden__qBIDP {
    display: none;
}

.tax-optimisation_actions__wm0IW {
    text-align: center;
    margin: auto auto 60px;
    padding-top: 32px;
}

.tax-optimisation_imgWrapper__BEeT0 {
    border: 1px solid #7b848e;
    margin-bottom: 12px;
    text-align: center;
    display: flex;
    flex-direction: column;
    padding: 4px 24px;
    color: #1650b4;
    font-size: 16px;
    width: 179px;
    max-height: 156px;
}

.tax-optimisation_imgWrapper__BEeT0 img {
    margin: 0 auto;
    max-width: 96%;
    height: auto;
}

.tax-optimisation_selection__xMuyb {
    width: 179px;
}

.tax-optimisation_selection__xMuyb img {
    width: 25px;
}

.tax-optimisation_selection__xMuyb h6,
.tax-optimisation_selection__xMuyb span {
    font-size: 13px;
}

.tax-optimisation_selection__xMuyb > div {
    margin-bottom: 4px;
    max-width: 100%;
}

.tax-optimisation_selection__xMuyb > div:not(:first-child) {
    padding-left: 32px;
}

.tax-optimisation_selection__xMuyb > div img {
    width: 20px;
}

.tax-optimisation_link__ZPJxc.tax-optimisation_open__1Ixrb {
    margin-right: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/TaxOptimisationTemplate/tax-optimisation.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,cAAc;IACd,8BAA8B;IAC9B,eAAe;IACf,sCAAsC;IACtC,YAAY;AAChB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,cAAc;IACd,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".content {\n    display: flex;\n    grid-gap: 40px;\n    /*width: calc(100vw - 200px);*/\n    max-width: 100%;\n    padding: 18px var(--container-padding);\n    margin: auto;\n}\n\n.groupsContainer {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n}\n\n.groups {\n    display: inline-flex;\n    flex-wrap: wrap;\n    grid-gap: 69px;\n    margin: 0 auto;\n    min-width: 1086px;\n}\n\n.group {\n    position: relative;\n    width: 250px;\n    /*transition: 0.1s;*/\n}\n\n.groupTitle {\n    margin: 0 0 40px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.groupTitle button.hidden {\n    display: none;\n}\n\n.groupTitle h4 {\n    color: #000;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 16px;\n    width: 270px;\n    margin: auto 0;\n}\n\n.group.closed .groupTitleNumber {\n    display: none;\n}\n\n.groupTitleNumber {\n    color: var(--secondary-color);\n    font-weight: 400;\n    padding-right: 10px;\n}\n\n.groupItems {\n    display: flex;\n    flex-wrap: wrap;\n    transition: padding 0.1s;\n}\n\n.groupItems.closed:has(a:nth-child(2):last-child) {\n    padding-top: 8px;\n    padding-left: 8px;\n}\n\n.groupItems.closed:has(a:nth-child(3):last-child) {\n    padding-top: 16px;\n    padding-left: 16px;\n}\n\n.groupItems.closed:has(a:nth-child(4)) {\n    padding-top: 24px;\n    padding-left: 24px;\n}\n\n.groupItems.closed * {\n    pointer-events: none;\n}\n\n.groupItems.open {\n    row-gap: 32px;\n}\n\n.group.open {\n    width: 100%;\n}\n\n.group.hidden {\n    display: none;\n}\n\n.actions {\n    text-align: center;\n    margin: auto auto 60px;\n    padding-top: 32px;\n}\n\n.imgWrapper {\n    border: 1px solid #7b848e;\n    margin-bottom: 12px;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    padding: 4px 24px;\n    color: #1650b4;\n    font-size: 16px;\n    width: 179px;\n    max-height: 156px;\n}\n\n.imgWrapper img {\n    margin: 0 auto;\n    max-width: 96%;\n    height: auto;\n}\n\n.selection {\n    width: 179px;\n}\n\n.selection img {\n    width: 25px;\n}\n\n.selection h6,\n.selection span {\n    font-size: 13px;\n}\n\n.selection > div {\n    margin-bottom: 4px;\n    max-width: 100%;\n}\n\n.selection > div:not(:first-child) {\n    padding-left: 32px;\n}\n\n.selection > div img {\n    width: 20px;\n}\n\n.link.open {\n    margin-right: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `tax-optimisation_content__q+q9Y`,
	"groupsContainer": `tax-optimisation_groupsContainer__8TA5K`,
	"groups": `tax-optimisation_groups__9uLxY`,
	"group": `tax-optimisation_group__5c-yj`,
	"groupTitle": `tax-optimisation_groupTitle__4QfpL`,
	"hidden": `tax-optimisation_hidden__qBIDP`,
	"closed": `tax-optimisation_closed__MjbEM`,
	"groupTitleNumber": `tax-optimisation_groupTitleNumber__Z3l4q`,
	"groupItems": `tax-optimisation_groupItems__U59zN`,
	"open": `tax-optimisation_open__1Ixrb`,
	"actions": `tax-optimisation_actions__wm0IW`,
	"imgWrapper": `tax-optimisation_imgWrapper__BEeT0`,
	"selection": `tax-optimisation_selection__xMuyb`,
	"link": `tax-optimisation_link__ZPJxc`
};
export default ___CSS_LOADER_EXPORT___;
